<!-- TABS -->
<div class="grid-row tabs dashboard-tabs mt-3 mb-4">
	<ul class="ps-0 mb-0">
		<!-- CONFIRMING -->
		@if (confirmingTabVisible) {
			<li
				[ngClass]="{
					'': !confirmingTabSelected,
					'is-active': confirmingTabSelected,
				}">
				<a (click)="clickedConfirmingTab()">
					{{ 'menu.Confirming' | translate }}
				</a>
			</li>
		}
		<!-- FACTORING -->
		@if (factoringTabVisible) {
			<li
				[ngClass]="{
					'': !factoringTabSelected,
					'is-active': factoringTabSelected,
				}">
				<a (click)="clickedFactoringTab()">
					{{ 'menu.Factoring' | translate }}
				</a>
			</li>
		}
	</ul>

	<!-- REFRESH BUTTON -->
	<eif-custom-button
		[text]="'button.refresh' | translate"
		[preIcon]="'fa-solid fa-sync-alt'"
		(action)="refreshAllData()">
	</eif-custom-button>
</div>

<!-- CONFIRMING AREA -->
@if (loggedUser?.canSeeConfirmingOptions()) {
	@if (confirmingTabSelected) {
		<div class="grid-row">
			<!-- CURRENCIES -->
			@if (orderedCurrencies.length > 1) {
				<ul class="currency-wrap mt-0 mb-4">
					@for (orderedCurrency of orderedCurrencies; track orderedCurrency.Currency; let i = $index) {
						<li>
							<eif-custom-button
								[text]="orderedCurrency.Currency"
								[variant]="orderedCurrency.Selected ? 'standard' : 'outlined'"
								[color]="orderedCurrency.Selected ? 'primary' : 'neutral'"
								(action)="clickedCurrency(orderedCurrency.Currency)">
							</eif-custom-button>
						</li>
					}
				</ul>
			}
			<div class="dashboard-cards-wrap">
				<eif-dashboard-card
					value="{{ contractedAmount | currencyLocale: selectedCurrency }}"
					description="{{ 'dashboard-financier.contractedAmount' | translate }}"
					[icon]="'fa-solid fa-chart-pie-alt'"
					[color]="'1'"
					[loading]="loadingContractedAmount" />
				<eif-dashboard-card
					value="{{ contractsAvailableAmount | currencyLocale: selectedCurrency }}"
					subValue="{{ contractsAvailableAmountRatio | numberLocale: '1.2-2' }}%"
					description="{{ 'dashboard-financier.contractsAvailableAmount' | translate }}"
					[icon]="'fa-regular fa-chart-pie-alt'"
					[color]="'2'"
					[loading]="loadingContractsAvailableAmount" />
				<eif-dashboard-card
					value="{{ notPaidDocuments | currencyLocale: selectedCurrency }}"
					description="{{ 'dashboard-financier.notPaidDocuments' | translate }}"
					[icon]="'fa-light fa-file-invoice'"
					[color]="'3'"
					[loading]="loadingNotPaidDocuments" />
				<eif-dashboard-card
					value="{{ approvedRequestFunds | currencyLocale: selectedCurrency }}"
					description="{{ 'dashboard-financier.approvedRequestFunds' | translate }}"
					[icon]="'fa-regular fa-hand-holding-dollar'"
					[color]="'4'"
					[loading]="loadingApprovedRequestFunds" />
				<eif-dashboard-card
					value="{{ currentFundingRequestsAmount | currencyLocale: selectedCurrency }}"
					description="{{ 'dashboard-financier.currentFundingRequestsAmount' | translate }}"
					[icon]="'fa-regular fa-hand-holding-dollar'"
					[color]="'5'"
					[loading]="loadingCurrentFundingRequestsAmount" />
				<eif-dashboard-card
					value="{{ monthlyAutomaticPayments | currencyLocale: selectedCurrency }}"
					description="{{ 'dashboard-financier.monthlyAutomaticPayments' | translate }}"
					[icon]="'fa-regular fa-usd-circle'"
					[color]="'6'"
					[loading]="loadingMonthlyAutomaticPayments" />
				<eif-dashboard-card
					value="{{ buyersWithActiveContractsCompaniesCount }}"
					description="{{ 'dashboard-financier.buyersCompaniesCount' | translate }}"
					[icon]="'fa-regular fa-building'"
					[color]="'1'"
					[loading]="loadingBuyersWithActiveContractsCompaniesCount" />
				<eif-dashboard-card
					value="{{ suppliersWithActiveConnectionsCompaniesCount }}"
					description="{{ 'dashboard-financier.suppliersCompaniesCount' | translate }}"
					[icon]="'fa-regular fa-building'"
					[color]="'2'"
					[loading]="loadingSuppliersWithActiveConnectionsCompaniesCount" />
				<eif-dashboard-card
					value="{{ suppliersActiveConnections }}"
					description="{{ 'dashboard-financier.suppliersActiveConnections' | translate }}"
					[icon]="'fa-regular fa-chart-network'"
					[color]="'8'"
					[loading]="loadingSuppliersActiveConnections" />
				<eif-dashboard-card
					value="{{ confirmingPendingApprovalDocumentsAmount }}"
					description="{{ 'dashboard-financier.confirmingPendingApprovalDocumentsAmount' | translate }}"
					[icon]="'fa-regular fa-hourglass-clock'"
					[color]="'7'"
					[loading]="loadingConfirmingPendingApprovalDocumentsAmount"
					[hasAction]="!loggedUser?.IsFinancier"
					(action)="navigateToFilesIntegration(FileStatus.PendingBuyerApproval)" />
			</div>
		</div>
	}
}

<!-- FACTORING AREA -->
@if (loggedUser?.canSeeFactoringOptions()) {
	@if (factoringTabVisible) {
		<div class="grid-row">
			@if (factoringTabSelected) {
				<div class="dashboard-cards-wrap">
					<eif-dashboard-card
						value="{{ factoringApprovedCreditAssignments | currencyLocale: CurrencyCode.Euro }}"
						description="{{ 'dashboard-financier.factoringApprovedCreditAssignments' | translate }} ({{ CurrentMonth }})"
						[icon]="'fa-regular fa-sack-dollar'"
						[color]="'1'"
						[loading]="loadingFactoringApprovedCreditAssignments" />
					<eif-dashboard-card
						value="{{ factoringCurrentCreditAssignmentsAmount | currencyLocale: CurrencyCode.Euro }}"
						description="{{ 'dashboard-financier.factoringCurrentCreditAssignmentsAmount' | translate }}"
						[icon]="'fa-regular fa-sack-dollar'"
						[color]="'2'"
						[loading]="loadingFactoringCurrentCreditAssignmentsAmount" />
					<eif-dashboard-card
						value="{{ factoringApprovedAdvances | currencyLocale: CurrencyCode.Euro }}"
						description="{{ 'dashboard-financier.factoringApprovedAdvances' | translate }} ({{ CurrentMonth }})"
						[icon]="'fa-regular fa-sack-dollar'"
						[color]="'3'"
						[loading]="loadingFactoringApprovedAdvances" />
					<eif-dashboard-card
						value="{{ factoringContractedAmount | currencyLocale: CurrencyCode.Euro }}"
						description="{{ 'dashboard-financier.factoringContractedAmount' | translate }}"
						[icon]="'fa-regular fa-sack-dollar'"
						[color]="'4'"
						[loading]="loadingFactoringContractedAmount" />
					<eif-dashboard-card
						value="{{ factoringContractDocumentPortfolioAmount | currencyLocale: CurrencyCode.Euro }}"
						description="{{ 'dashboard-financier.factoringContractDocumentPortfolioAmount' | translate }}"
						[icon]="'fa-regular fa-sack-dollar'"
						[color]="'1'"
						[loading]="loadingFactoringContractDocumentPortfolioAmount" />
					<eif-dashboard-card
						value="{{ factoringContractAdvanceableAmount | currencyLocale: CurrencyCode.Euro }}"
						description="{{ 'dashboard-financier.factoringContractAdvanceableAmount' | translate }}"
						[icon]="'fa-regular fa-sack-dollar'"
						[color]="'2'"
						[loading]="loadingFactoringContractAdvanceableAmount" />
					<eif-dashboard-card
						value="{{ factoringSuppliersWithActiveContractsCompaniesCount }}"
						description="{{ 'dashboard-financier.factoringSuppliersWithActiveContractsCompaniesCount' | translate }}"
						[icon]="'fa-regular fa-sack-dollar'"
						[color]="'3'"
						[loading]="loadingFactoringSuppliersWithActiveContractsCompaniesCount" />
					<eif-dashboard-card
						value="{{ factoringBuyersWithActiveConnectionsCompaniesCount }}"
						description="{{ 'dashboard-financier.factoringBuyersWithActiveConnectionsCompaniesCount' | translate }}"
						[icon]="'fa-regular fa-sack-dollar'"
						[color]="'4'"
						[loading]="loadingFactoringBuyersWithActiveConnectionsCompaniesCount" />
					<eif-dashboard-card
						value="{{ factoringBuyersActiveConnections }}"
						description="{{ 'dashboard-financier.factoringBuyersActiveConnections' | translate }}"
						[icon]="'fa-regular fa-sack-dollar'"
						[color]="'8'"
						[loading]="loadingFactoringBuyersActiveConnections" />
					<eif-dashboard-card
						value="{{ factoringPendingApprovalDocumentsAmount }}"
						description="{{ 'dashboard-financier.factoringPendingApprovalDocumentsAmount' | translate }}"
						[icon]="'fa-regular fa-hourglass-clock'"
						[color]="'7'"
						[loading]="loadingFactoringPendingApprovalDocumentsAmount"
						[hasAction]="!loggedUser?.IsFinancier"
						(action)="navigateToFilesIntegration(FileStatus.PendingSupplierApproval)" />
				</div>
			}
		</div>
	}
}
